import { api } from '..'

export const refreshCookie = () => api.post('/v1/accounts/refresh-token')
